module.exports = __webpack_public_path__ + "static/img/dl_apple.82efcf3b.png";